export default __webpack_public_path__ + "static/stats-green-background-20cceacd088192b651032ca959a92e3a.png";